import {useState, useEffect} from "react";
import {orderBySingleField} from "../../../../libs/arrayUtils";

const useFilterAndSorterTemplates = (
  categoryFilterValue, authorFilterValue, ratingFilterValue, templates /* priceSortingOrder*/
) => {
  const [ templatesFilteredAndSorted, setMockedTemplatesFilteredAndSorted ] = useState([]);
  useEffect(() => {
    if (categoryFilterValue === null && authorFilterValue === null && ratingFilterValue === null){
      const sortedByDateTemplates = (orderBySingleField(templates, "insertTimestamp"));
      /* to develop once we will have the price in the data structure */
      /* const sortedByDateAndPriceTemplates = (orderBySingleField(sortedByDateTemplate, "insertTimestamp", [priceSortingOrder === "desc" ? "desc" : "asc"])); */
      setMockedTemplatesFilteredAndSorted(sortedByDateTemplates);
    }
    if (categoryFilterValue !== null && authorFilterValue === null && ratingFilterValue === null){
      const templatesByCategory = templates.filter(t => {
        return t.category === categoryFilterValue;
      });
      const sortedByDateTemplates = (orderBySingleField(templatesByCategory, "insertTimestamp"));
      setMockedTemplatesFilteredAndSorted(sortedByDateTemplates);
    } else if (categoryFilterValue === null && authorFilterValue !== null && ratingFilterValue === null){
      const templatesByAuthors = templates.filter(t => {
        return t.authorName === authorFilterValue;
      });
      const sortedByDateTemplates = (orderBySingleField(templatesByAuthors, "insertTimestamp"));
      setMockedTemplatesFilteredAndSorted(sortedByDateTemplates);
    } else if (categoryFilterValue === null && authorFilterValue === null && ratingFilterValue !== null){
      const templatesByRatings = templates.filter(t => {
        return t.score === ratingFilterValue;
      });
      const sortedByDateTemplates = (orderBySingleField(templatesByRatings, "insertTimestamp"));
      setMockedTemplatesFilteredAndSorted(sortedByDateTemplates);
    } else if (categoryFilterValue !== null && authorFilterValue !== null && ratingFilterValue === null){
      const templatesByCategoryAndAuthor = templates.filter(t => {
        return t.category === categoryFilterValue;
      }).filter(t => {
        return t.authorName === authorFilterValue;
      });
      const sortedByDateTemplates = (orderBySingleField(templatesByCategoryAndAuthor, "insertTimestamp"));
      setMockedTemplatesFilteredAndSorted(sortedByDateTemplates);
    } else if (categoryFilterValue !== null && authorFilterValue !== null && ratingFilterValue !== null){
      const templatesByAllFilters = templates.filter(t => {
        return t.category === categoryFilterValue;
      }).filter(t => {
        return t.authorName === authorFilterValue;
      }).filter(t => {
        return t.score === ratingFilterValue;
      });
      const sortedByDateTemplates = (orderBySingleField(templatesByAllFilters, "insertTimestamp"));
      setMockedTemplatesFilteredAndSorted(sortedByDateTemplates);
    } else if (categoryFilterValue !== null && authorFilterValue === null && ratingFilterValue !== null){
      const templatesByCategoryAndRating = templates.filter(t => {
        return t.category === categoryFilterValue;
      }).filter(t => {
        return t.score === ratingFilterValue;
      });
      const sortedByDateTemplates = (orderBySingleField(templatesByCategoryAndRating, "insertTimestamp"));
      setMockedTemplatesFilteredAndSorted(sortedByDateTemplates);
    } else if (categoryFilterValue === null && authorFilterValue !== null && ratingFilterValue !== null){
      const templatesByAuthorAndRating = templates.filter(t => {
        return t.authorName === authorFilterValue;
      }).filter(t => {
        return t.score === ratingFilterValue;
      });
      const sortedByDateTemplates = (orderBySingleField(templatesByAuthorAndRating, "insertTimestamp"));
      setMockedTemplatesFilteredAndSorted(sortedByDateTemplates);
    }
  }, [categoryFilterValue, authorFilterValue, ratingFilterValue]);

  return templatesFilteredAndSorted;
};

export default useFilterAndSorterTemplates;